import { DRAW_STRUCTURE_SET_EDITOR_TYPE, DRAW_STRUCTURE_SET_LOADING } from '@Pages/RetroSynthesis/DrawStructure/constants';

export const initialState = {
  editorType: undefined,
  isLoading: false,
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case DRAW_STRUCTURE_SET_EDITOR_TYPE: {
      const { editorType } = action.payload;
      return { ...state, editorType };
    }
    case DRAW_STRUCTURE_SET_LOADING: {
      const { isLoading } = action.payload;
      return { ...state, isLoading };
    }
    default: {
      return state;
    }
  }
}
